/**
 * Where the portal's API lives.
 *
 * The worker is deployed to its own subdomain (see `apps/api/wrangler.toml`
 * for why it isn't a path on this one), so this can't be a relative URL. It's
 * resolved at build time rather than from a Pages environment variable because
 * the portal's deploy configuration lives in the Cloudflare dashboard, outside
 * this repo — a value that has to be set in two places is a value that will
 * eventually be set in one. `VITE_API_BASE_URL` still overrides it for anyone
 * pointing a local portal at a deployed worker, or vice versa.
 */
const configured: string | undefined =
  import.meta.env.VITE_API_BASE_URL?.trim();

/** Blank counts as unset: clearing a dashboard field usually leaves `""`
 * behind rather than removing the variable, and `??` would take that as a
 * deliberate choice — turning every API call into a same-origin request
 * against the portal itself, which fails silently. */
export const API_BASE_URL: string =
  configured ||
  (import.meta.env.DEV
    ? "http://localhost:8787"
    : "https://api.bigbearbackup.com");
